import React, { useContext, useState } from 'react';
import Isvg from 'react-inlinesvg';
import ReactModal from 'react-modal';

import Button from 'components/Button';
import Message from 'components/Message';
import { PlainSwitch } from 'components/Switch';
import When from 'components/When';
import { ICONS, PFE_ICONS } from 'constants/icons';
import LINKS from 'constants/links';
import { bem } from 'helpers/class-name';

import CookiesContext, { CONSENT_MODELS } from '../CookiesContext';

import { messages } from './CookieModal.messages';

import './CookieModal.scss';

const { block, element } = bem('cookie-modal');

function CookieModal() {
  const { consentModel, showModal, saveCurrentSelection } = useContext(CookiesContext);
  const usesCCPARules = consentModel === CONSENT_MODELS.CCPA_RULES;

  const [functionalConsent, setFunctionalConsent] = useState(true);
  function onFunctionalSwitchClick() {
    setFunctionalConsent(!functionalConsent);
  }

  const [marketingAndAdvertisingConsent, setMarketingAndAdvertisingConsent] = useState(true);
  function onMarketingAndAdvertisingSwitchClick() {
    setMarketingAndAdvertisingConsent(!marketingAndAdvertisingConsent);
  }

  function confirmCurrentSelection() {
    saveCurrentSelection({
      essential: true,
      functional: functionalConsent,
      marketingAndAdvertising: marketingAndAdvertisingConsent,
    });
  }

  return (
    <ReactModal
      isOpen={showModal}
      shouldFocusAfterRender={false}
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      ariaHideApp={process.env.NODE_ENV !== 'test'}
      bodyOpenClassName="cookie-modal-open"
      overlayClassName={element('overlay')}
      className={block()}
      onRequestClose={confirmCurrentSelection}>
      <h3 className={element('header')}>
        <Message message={messages.header} />
        <When predicate={!usesCCPARules}>
          <Isvg src={ICONS.cross} className={element('close-icon')} onClick={confirmCurrentSelection} />
        </When>
      </h3>

      <p className={element('description')}>
        <Message message={messages.description} />
      </p>

      {/* Categories START */}
      <div className={element('category', { essential: true })}>
        <h4 className={element('category-name')}>
          <Message message={messages.categories.essential.name} />
        </h4>
        <p className={element('category-description')}>
          <Message message={messages.categories.essential.description} />
        </p>
        <PlainSwitch checked disabled className={element('category-switch', { essential: true })} />
      </div>

      <div className={element('category', { functional: true })}>
        <h4 className={element('category-name')}>
          <Message message={messages.categories.functional.name} />
        </h4>
        <p className={element('category-description')}>
          <Message message={messages.categories.functional.description} />
        </p>
        <PlainSwitch
          checked={functionalConsent}
          inputProps={{ readOnly: true, onClick: onFunctionalSwitchClick }}
          className={element('category-switch')}
        />
      </div>

      <div className={element('category', { marketingAndAdvertising: true })}>
        <h4 className={element('category-name')}>
          <Message message={messages.categories.marketingAndAdvertising.name} />
        </h4>
        <p className={element('category-description')}>
          <Message message={messages.categories.marketingAndAdvertising.description} />
        </p>
        <PlainSwitch
          checked={marketingAndAdvertisingConsent}
          inputProps={{ readOnly: true, onClick: onMarketingAndAdvertisingSwitchClick }}
          className={element('category-switch')}
        />
      </div>
      {/* Categories END */}

      <div className={element('footer')}>
        <Isvg src={PFE_ICONS.logotype} className={element('logo')} />
        <div className={element('footer-bar')} />
        <Button styled="link" className={element('action', { link: true })}>
          <Message
            as="a"
            href={LINKS.privacyPolicy.href}
            target="_blank"
            rel="noreferrer noopener"
            message={messages.privacyPolicy}
          />
        </Button>
        <Button styled="primary" className={element('action', { primary: true })} onClick={confirmCurrentSelection}>
          <Message message={messages.agreeAndProceed} />
        </Button>
      </div>
    </ReactModal>
  );
}

export default CookieModal;
